import { componentStyles } from "./marquee-product-card.scss";
import PictureComponent from "components/core/picture/picture-component";
import Title from "segments/desktop/core-components/title/title";
import CheckboxSVG from "segments/desktop/core-components/product-card/checkbox-icon";
import { XS } from "/components/core/new-button/button-component";
import { useState } from "react";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import classnames from "classnames";
import { PRODUCT_ID_TO_LOGO, BUTTON_CONFIG_BY_PRODUCT } from "./consts";
import { WHITE_COLOR_NAME } from "styles/color-consts";
import Paragraph from "segments/desktop/core-components/paragraph/paragraph";

const MarqueeProductCard = (props) => {
  const { card } = props;
  const { cardAsset, titleText, useCases, productType, cardLogoAsset } = card;

  const [isHovered, setIsHovered] = useState(false);
  const [isHoverTransition, setIsHoverTransition] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
    setIsHoverTransition(false);
  };

  const handleMouseLeave = () => {
    if (isHovered) setIsHoverTransition(true);
    setIsHovered(false);
  };

  return (
    <div className="marquee-product-card" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <div className="picture-wrapper">
        <PictureComponent src={cardAsset} />
      </div>
      <div className={classnames("card-content", { up: isHovered, down: isHoverTransition })}>
        <div className="title-wrapper">
          <Title title={titleText} titleColor="white" titleSize={XS} />
        </div>
        <div className="use-cases-wrapper">
          {useCases?.map(({ useCase }) => (
            <div className="use-case">
              <CheckboxSVG />
              {useCase}
            </div>
          ))}
        </div>

        <div className="product-logo-wrapper">
          <div className="recommended-product-text">
            <Paragraph body="Recommended product" />
          </div>
          <PictureComponent src={cardLogoAsset || PRODUCT_ID_TO_LOGO[productType]} />
        </div>
        <div className="seperator-line" />
        <div className="product-signup-wrapper">
          <SignupButton
            buttonSize={XS}
            {...BUTTON_CONFIG_BY_PRODUCT[productType]}
            buttonColor={WHITE_COLOR_NAME}
            withButtonArrow={false}
          />
        </div>
      </div>
      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default MarqueeProductCard;
